export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32 md:pt-40 pb-20"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbHV4dXJ5JTIwZ29sZCUyMGFic3RyYWN0fGVufDB8fHx8MTc3NjE3MjU0M3ww&ixlib=rb-4.1.0&q=85')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/70 to-[#050505]" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <p
          data-testid="hero-overline"
          className="text-xs tracking-[0.3em] uppercase metal-gold-text mb-8 animate-fade-slide-up"
          style={{ animationDelay: "0.1s" }}
        >
          La Grotta Records Presents
        </p>

        <img
          src="/brand/logotype.png"
          alt="Sanctum Sonics"
          data-testid="hero-logotype"
          className="w-full max-w-md sm:max-w-lg lg:max-w-2xl mx-auto mb-6 animate-fade-slide-up"
          style={{ animationDelay: "0.3s" }}
        />
        <img
          src="/brand/logo.png"
          alt="Sanctum Sonics emblem"
          data-testid="hero-logo"
          className="h-48 sm:h-64 lg:h-72 w-auto mx-auto mb-8 drop-shadow-[0_0_45px_rgba(212,175,55,0.28)] animate-fade-slide-up"
          style={{ animationDelay: "0.45s" }}
        />

        <p
          data-testid="hero-claim"
          className="text-2xl md:text-3xl lg:text-4xl italic text-[#EAEAEA] mb-4 animate-fade-slide-up"
          style={{ fontFamily: "'Cormorant Garamond', serif", animationDelay: "0.55s" }}
        >
          Forged in the Darkness. Primed for the Light.
        </p>
        <p
          data-testid="hero-subtitle"
          className="text-sm md:text-base text-[#737373] tracking-wide font-light mb-10 animate-fade-slide-up"
          style={{ animationDelay: "0.65s" }}
        >
          Premium beats crafted for artists who demand the exceptional.
        </p>

        <div
          className="flex items-center justify-center gap-4 animate-fade-slide-up"
          style={{ animationDelay: "0.7s" }}
        >
          <button
            data-testid="hero-browse-btn"
            onClick={() => {
              const el = document.getElementById("beats");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="metal-gold-surface px-9 py-3.5 font-semibold text-sm tracking-widest uppercase rounded-full transition-all hover:brightness-105"
          >
            Browse Catalog
          </button>
          <button
            data-testid="hero-forge-btn"
            onClick={() => {
              const el = document.getElementById("forge");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="chrome-dark px-9 py-3.5 border border-gold/60 text-[#F2D072] font-semibold text-sm tracking-widest uppercase rounded-full transition-all hover:border-gold hover:brightness-110"
          >
            The Forge
          </button>
        </div>
      </div>
    </section>
  );
}
